import { CommandIdentifierEnum } from "@pharaday/command-palette";

import { ApplicationTypeEnum } from "../core/domain/enums/application-type.enum";

export const getAppCommandIdentifier = (type: ApplicationTypeEnum): CommandIdentifierEnum | undefined => {
  switch (type) {
    case ApplicationTypeEnum.PORT:
      return CommandIdentifierEnum.GO_TO_PORT_APP;

    case ApplicationTypeEnum.CHARTERER:
      return CommandIdentifierEnum.GO_TO_CHARTERER_APP;

    default:
      return undefined;
  }
};
